export const TYPES = {
    LEAGUE : "league",
    TOURNAMENT: "tournament",
    PICKUP: "pickup"
}